export default __webpack_public_path__ + "static/media/eyepatch.bc0fa4c1.png";